const map = require('lodash/fp/map');
const memoizer = require('../request-handler/utils/memoizer');

function parseResult(res) {
  return JSON.stringify(res);
}

function parseCountryResult(res) {
  if ((!res) || res.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(res);
  }
}

function serviceFactory({ api }) {
  const getBankDetails = (details, metaData) =>
    api.getBankDetails(details, metaData)
      .then(parseResult)
      .catch(() => null);
    

  const getCountryList = (country, metaData) =>
    api.getCountryList(country, metaData)
      .then(parseCountryResult)
      .catch(() => null);

  const getFilterLists = (metaData) =>
    api.getFilterLists(metaData)
      .then(parseResult)
      .catch(() => null);

  const listTransactions = ((inputs, metaData) =>
    api.listTransactions(inputs, metaData)
      .then(parseResult)
      .catch((error) => {
        return null;
      })
  );
  const viewPaymentOrder = memoizer()((inputs, metaData) =>
    api.viewPaymentOrder(inputs, metaData)
      .then(parseResult)
      .catch((error) => {
        return null;
      })
  );

  const addBeneficiaryDetails = memoizer()((inputParam, metaData) =>
    api.addBeneficiaryDetails(inputParam, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const getBeneficiaryList = (inputParam, metaData) =>
  api.getBeneficiaryList(inputParam, metaData)
  .then(parseResult)
  .catch(() => null);

  const editBeneficiaryDetails = memoizer()((inputParam, metaData) =>
    api.editBeneficiaryDetails(inputParam, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const deleteBeneficiary = memoizer()((inputParam, metaData) =>
    api.deleteBeneficiary(inputParam, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const getTemplateList = (metaData) =>
  api.getTemplateList(metaData)
  .then(parseResult)
  .catch(() => null);

  const deleteTemplate = (inputParam, metaData) =>
  api.deleteTemplate(inputParam, metaData)
  .then(parseResult)
  .catch(() => null);
  
  const saveUpdateTemplate = (inputParam, metaData) =>
  api.saveUpdateTemplate(inputParam, metaData)
  .then(parseResult)
  .catch(() => null);

  const getStandingOrderList = memoizer()((inputs, metaData) =>
    api.getStandingOrderList(inputs, metaData)
      .then(parseResult)
      .catch((error) => {
        return null;
      })
  );

  return {
    getBankDetails,
    getCountryList,
    getFilterLists,
    addBeneficiaryDetails,
    listTransactions,
    getBeneficiaryList,
    editBeneficiaryDetails,
    deleteBeneficiary,
    getTemplateList,
    deleteTemplate,
    saveUpdateTemplate,
    getStandingOrderList,
    viewPaymentOrder
  };

}
module.exports = serviceFactory;